import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@backslashbuild/pp-ui";
import {
  Content,
  PageTitle,
  PanelColumn,
  PageHeadingArea,
  PanelColumnSet,
} from "@backslashbuild/pp-ui";
import NewBranchForm from "../modules/agencies/NewBranchForm";

export default function CreateBranch() {
  const { agencyId } = useParams();

  return (
    <Content scrollable>
      <PageHeadingArea>
        <PageTitle>Create Branch</PageTitle>
      </PageHeadingArea>

      <PanelColumnSet>
        <PanelColumn>
          <NewBranchForm agencyId={agencyId} />
        </PanelColumn>
      </PanelColumnSet>
    </Content>
  );
}
